<template>
  <!-- 补充项目报告扫描件 -->
  <div class="project_reports_proposal">
    <div class="project_reports_first">
      <div class="project_reports_name">补充项目报告扫描件</div>
      <div
        :class="'project_reports project_reports_' + dataObject.synergeticState"
      >
        {{ judgmentStatus(dataObject.synergeticState) }}
      </div>
    </div>
    <div style="padding-left: 5px">
      <el-form label-width="100px" label-position="left">
        <el-form-item label="报告名称：">
          <div>{{ dataObject.boxSynergeticReportVo.reportName }}</div>
        </el-form-item>
        <el-form-item label="所属项目：">
          <div>{{ dataObject.boxSynergeticReportVo.projectName }}</div>
        </el-form-item>
        <el-form-item label="业务类型：">
          <div>{{ dataObject.boxSynergeticReportVo.businessTypeName }}</div>
        </el-form-item>
        <el-form-item label="任务接收人：">
          <div>
            <span
              v-for="(item, index) in dataObject.boxEmplList"
              style="margin-right: 6px"
              :key="index"
              >{{ item.trueName }}</span
            >
            <el-button
              type="warning"
              size="mini"
              v-if="dataObject.synergeticState !== 'YWC'"
              @click="increaseRecipient"
              >添加接收人</el-button
            >
          </div>
        </el-form-item>
        <el-form-item label="任务截至时间：" label-width="110px">
          <div>{{ dataObject.jobOverDate }}</div>
        </el-form-item>
        <el-form-item label="任务说明：">
          <div>
            {{ dataObject.jobDesc }}
          </div>
        </el-form-item>
        <el-divider></el-divider>
        <el-form-item label="报告扫描件：" label-width="110px">
          <JYOssUploadFiles
            :file-list="dataObject.boxSynergeticReportVo.throwFileEntities"
            :statusIsEdit="dataObject.synergeticState == 'YWC'"
            :accept="'.doc,.docx,.pdf,.xlsx,.xls,.png,.jpg,.jpeg'"
          />
        </el-form-item>
        <div style="text-align: center; margin-top: 20px">
          <el-button
            type="primary"
            v-if="dataObject.synergeticState !== 'YWC'"
            @click="confirmCompletion"
            >确认完成</el-button
          >
        </div>
      </el-form>
    </div>
    <!-- 添加接收人 -->
    <el-dialog
      title="添加接收人"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose"
    >
      <el-form
        ref="recipientForm"
        :model="recipientForm"
        :rules="recipientRules"
        label-position="left"
        label-width="140px"
        class="demo-ruleForm"
      >
        <el-form-item label="接收人：" prop="employeeId">
          <el-select
            v-model="recipientForm.employeeId"
            filterable
            clearable
            placeholder="请选择接收人"
            style="width: 100%"
          >
            <el-option
              v-for="item in personnelList"
              :key="item.employeeId"
              :label="item.trueName"
              :value="item.employeeId + ',' + item.trueName"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <div style="text-align: center; margin-top: 20px">
          <el-button type="primary" @click="submit('recipientForm')"
            >提交</el-button
          >
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { addBoxEmpl, addFinish, auditBack, manufacturingcostBack, supervisorBack } from '@/api/bidBox'
import BoxFileList from '@/components/uploadfiel/boxFileList'
import { fileUpload } from '@/api/publiccommon'
export default {
  name: 'ProjectReports',
  components: {
    BoxFileList
  },
  computed: {

  },
  props: {
    dataObject: {
      type: Object,
      default: {},
      required: true
    },
    personnelList: {
      type: Array,
      default: {},
      required: true
    },
    btnauth: {
      type: Array,
      default: {},
      required: true
    },
  },
  data () {
    return {
      dialogVisible: false,
      recipientForm: {
        employeeId: ''
      },//接收人 表单提交
      recipientRules: {
        employeeId: [
          { required: true, message: '请选择接收人', trigger: 'change' }
        ]
      }
    }
  },
  watch: {

  },
  created () {

  },
  mounted () {

  },
  methods: {
    // 打开 添加接收人 表单
    increaseRecipient () {
      this.dialogVisible = true
    },
    // 提交添加 接收人
    submit (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let arr = this.recipientForm.employeeId.split(',')
          let par = {
            boxId: this.dataObject.boxId,
            employeeId: arr[0],
            trueName: arr[1]
          }
          addBoxEmpl(par).then(res => {
            if (res.status === 200) {
              this.$message.success('接收人添加成功')
              this.recipientForm = {
                employeeId: ''
              }//接收人 表单提交
              this.$refs[formName].resetFields()
              this.$emit('renewList')
              this.dialogVisible = false
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    // 关闭接收人 表单
    handleClose () {
      this.$confirm('确认关闭？')
        .then(_ => {
          this.dialogVisible = false
          this.$refs['recipientForm'].resetFields()
        })
        .catch(_ => { })
    },
    // 确认完成
    confirmCompletion () {
      if (this.dataObject.boxSynergeticReportVo.throwFileEntities.length === 0) {
        return this.$message.warning('请上传报告扫描件！')
      } else {
        this.dataObject.boxSynergeticReportVo.throwFileEntities.forEach(item => {
          item.businessType = 'BG'
        })
      }
      this.$confirm('此操作将确认完成, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let par = {
          boxId: this.dataObject.boxId,
          businessId: this.dataObject.boxId,
          modleType: this.dataObject.modleType,
          modleId: this.dataObject.modleId,
          throwFileEntities: this.dataObject.boxSynergeticReportVo.throwFileEntities
        }
        addFinish(par).then(res => {
          if (res.status === 200) {
            this.$message.success('已确认完成')
            this.reportBackfill(this.dataObject.boxSynergeticReportVo.businessTypeName)
            this.$emit('renewList')
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消确认完成'
        })
      })
    },
    // 判断状态
    judgmentStatus (type) {
      if (type === 'DWC') {
        return '待完成'
      } else if (type === 'YWC') {
        return '已完成'
      } else if (type === 'YZF') {
        return '已作废'
      }
    },
    // 报告扫描件回填
    reportBackfill (type) {
      if (type === '审计') {
        let par = {
          reportId: this.dataObject.boxSynergeticReportVo.reportId,
          scanFilePo: this.dataObject.boxSynergeticReportVo.throwFileEntities
        }
        auditBack(par).then(res => {
          if (res.status === 200) {
            this.$message.success('回填成功')
          }
        })
      } else if (type === '造价') {
        let par = {
          reportId: this.dataObject.boxSynergeticReportVo.reportId,
          scanFilePo: this.dataObject.boxSynergeticReportVo.throwFileEntities
        }
        manufacturingcostBack(par).then(res => {
          if (res.status === 200) {
            this.$message.success('回填成功')
          }
        })
      } else if (type === '监理') {
        let par = {
          projectDebriefingFileId: this.dataObject.boxSynergeticReportVo.reportId,
          fileList: this.dataObject.boxSynergeticReportVo.throwFileEntities
        }
        supervisorBack(par).then(res => {
          if (res.status === 200) {
            this.$message.success('回填成功')
          }
        })
      }
    }
  },
}
</script>

<style lang="scss" scoped>
.project_reports_proposal {
  margin-bottom: 20px;
  padding: 20px;
  border: 1px solid #11ddf8;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  .project_reports_first {
    display: flex;
    justify-content: space-between;
    .project_reports_name {
      margin-bottom: 20px;
      font-size: 16px;
      font-weight: 700;
    }
    .project_reports {
      height: 32px;
      padding: 0 10px;
      line-height: 30px;
      font-size: 12px;
      border-style: solid;
      border-radius: 4px;
      box-sizing: border-box;
      white-space: nowrap;
    }
    .project_reports_YWC {
      color: #026235;
      border: 1px solid #00f985;
      background: #b9e9d3;
    }
    .project_reports_DWC {
      color: #a10303;
      border: 1px solid #a10303;
      background: #f0a7a7;
    }
    .project_reports_YCH {
      color: #909399;
      border: 1px solid #909399;
      background: #f4f4f5;
    }
  }
}
::v-deep .el-form-item {
  margin-bottom: 0 !important;
}
::v-deep .text-ellipsis {
  max-width: 9vw;
}
</style>
